// extracted by mini-css-extract-plugin
export default {"loading-container":"loading-container___tw_dx","required-text":"required-text___X7TnR","table-parent":"table-parent___m6fNG"};